import { jsx as e } from "react/jsx-runtime";
import { ColorModeScript as f, extendTheme as a, ChakraProvider as h } from "@chakra-ui/react";
import { createContext as p } from "react";
import { createSemanticTokens as d } from "./theme-config/theme.js";
import { casperUITheme as o } from "./theme-config/theme-casper-ui.js";
import { componentsConfig as S } from "./theme-config/theme-components.js";
const C = p({
  colors: o.colors,
  fonts: o.fonts,
  fontStyleSheet: o.fontStyleSheet,
  globalStyles: o.globalStyles
});
function M({
  colors: t = o.colors,
  fonts: r = o.fonts,
  fontStyleSheet: n = o.fontStyleSheet,
  globalStyles: i = o.globalStyles,
  children: l
}) {
  const m = {
    cssVarPrefix: "theme",
    initialColorMode: "light",
    useSystemColorMode: !1
  }, s = { global: { ...i, fontStyleSheet: n } }, c = a({
    semanticTokens: d(t, r),
    components: S,
    config: m,
    styles: s
  });
  return /* @__PURE__ */ e(C.Provider, { value: { colors: t, fonts: r, fontStyleSheet: n, globalStyles: i }, children: /* @__PURE__ */ e(h, { theme: c, children: l }) });
}
function P() {
  return /* @__PURE__ */ e(f, { initialColorMode: "light" });
}
export {
  P as ThemeColorModeScript,
  M as ThemeProvider,
  C as ThemeProviderContext
};
